import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import {
  AgrPageDetailModule,
  AgrPrintPageModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { LetDirective, PushPipe } from '@ngrx/component';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { FertilizationLegalStandardsQuickViewComponent } from './fertilization-legal-standards-quick-view.component';
import { NitrogenCutsComponent } from './nitrogen-cuts/nitrogen-cuts.component';
import { LegalStandardEffects } from './store/legal-standard.effects';
import { legalStandardReducer } from './store/legal-standard.reducer';

@NgModule({
  declarations: [FertilizationLegalStandardsQuickViewComponent, NitrogenCutsComponent],
  imports: [
    CommonModule,
    AgrPageDetailModule,
    AgrI18nSharedModule,
    AgrPrintPageModule,
    AgrValueRowModule,
    LetDirective,
    PushPipe,
    MatDividerModule,
    MatIconModule,
  ],
  providers: [provideState('legalStandard', legalStandardReducer), provideEffects(LegalStandardEffects)],
  exports: [FertilizationLegalStandardsQuickViewComponent, NitrogenCutsComponent],
})
export class LegalStandardModule {}
